import React, { useCallback } from 'react';

import { Container, Content, Icon } from './styles';

interface Props {
  icon: string;
  title?: string;
  description?: string;
  children?: JSX.Element;
  type: string;
  isSelected: boolean;
  onClick: (value: string) => void;
}

const ApprovalCardType = ({ icon, title, description, type, isSelected, onClick, children }: Props) => {
  const handleClick = useCallback(() => {
    onClick(type);
  }, [type, onClick]);

  return (
    <Container isSelected={isSelected} onClick={handleClick}>
      <Icon>
        <img alt="card-type-approval" src={icon} />
      </Icon>
      <Content>
        {children ? (
          <>{children}</>
        ) : (
          <>
            <h3>{title}</h3>
            {description && <p>{description}</p>}
          </>
        )}
      </Content>
    </Container>
  );
};

export default ApprovalCardType;
